import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
})
